import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/26/thumb-landscape.jpg"

const Post26 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOUIS VUITTON／ネオアルマBB／23 x18 x11cm</span>    
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>バッグ選びに悩む方から、よく耳にする言葉があります。<br></br>「これ古くない？」<br></br>ここでいう「古い」とは単純に新品と比較してではなく、流行遅れではないか？これを持つことはダサくないか？という不安からです。<br></br>コロナによって、私たちの様々な生活様式に変化がありましたが、ファッションマインドもそのひとつ。毎シーズン、トレンドを追うことに疑問を持ち始めた人が増えています。<br></br>自分にあった、自分に好きなものを持とう！これが今のファッショントレンドです。<br></br>自分のスタイルを持つ4名にお話を聞きました。お気に入りのルイ・ヴィトンのバッグを紹介してもらいます。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ブレアGM【モノグラム・ヴェルニ】</h2>
          <figure>
            <StaticImage src="../../images/posts/26/1.jpg" alt="" />
          </figure>
          <p>女性らしいファッションがお得意のSAKIさんが選んだバッグは、「ブレアGM　モノグラム・ヴェルニ」。彼女のキャラクター通り、ピンクベージュの優しい色合いがよくお似合いです。ルイ・ヴィトンには特別な思い入れがあるというSAKIさんに愛用バッグを教えてもらいました。</p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/26/2.jpg" alt="" />
        </figure>  
        <div className="text-max-width">
          <h2>このバッグのここがスキ♡</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>SAKIさん（以下、SAKI）：</span>実はこのバッグ、わたしにとっては冒険心がつまってるんです（笑）<br></br>まず、エナメル素材。光沢のある素材って洋服のコーデが限られるんじゃないかって思ってます。レザーやキャンバスには馴染みがありますが、エナメルはハードルが高いと感じてました。<br></br>それから、サイズ。小さいバッグが好きで、いつも必要最低限の荷物しか持ち歩かない私にとって、この大きさは挑戦なんです！<br></br>素材も大きさも冒険なんですけど、手にすると新鮮な気持ちでワクワクします。ファッションって楽しいなって、あらためて思っちゃった（笑）</p>
        </div>
        <div className="text-max-width">
          <h2>使い勝手はどう？</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>SAKI：</span>光沢があるエナメルがコーデしにくいんじゃないかと心配してましたが、このピンクベージュを選んだのが正解だったかも。<br></br>柔らかい色だからか、合わせやすいし大人っぽい雰囲気が出て気に入っています。<br></br>それから、大きめバッグって使いやすいんですね。ポンポンとなんでもバッグにいれられるって癖になりそうです（笑）<br></br>これからは、どっちかに偏るんじゃなくて用途によって使い分けたいなって。</p>
        </div>
        <div className="text-max-width">
          <h2>ヴェルニ</h2>
          <figure>
            <StaticImage src="../../images/posts/26/3.jpg" alt="" />
          </figure>          
          <p>当時のアーティスティック・デレクターだったマーク・ジェイコブスにより、ルイ・ヴィトン初のファッションショーに合わせ1998年に登場した素材です。<br></br>モノグラム・モチーフを型押し、エナメルコーティングしたカラフルなレザーが特徴的。<br></br>それまでクラシカルなイメージだったモノグラムのイメージをガラリと変えました。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/26/4.jpg" alt="" />
          <span className="text-center">37x26x13cm</span>
        </figure>        
        <div className="text-max-width">
          <h2>【番外】受け継いだルイ・ヴィトン</h2>
          <figure>
            <StaticImage src="../../images/posts/26/5.jpg" alt="" />
          </figure>          
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>SAKI：</span>ヴィトンが大好きになったきっかけは、このバッグ。<br></br>母が若い頃に使っていたものです。母から9歳上の姉が譲り受け、私が二十歳を迎えた時に姉が譲ってくれました。<br></br>ブランドバッグは着物のように、受け継いでいけるものです。<br></br>まるで、バッグが旅してるみたいに持ち主を渡り歩いている。なんか、いいなぁって思います。<br></br>私も次の旅先に案内できるように、大切にしている宝物です。</p>
        </div>    
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>スピーディ30【LOUIS VUITTON×Jeff Koons】</h2>
          <figure>
            <StaticImage src="../../images/posts/26/6.jpg" alt="" />
          </figure>
          <p>個性的なアイテムもなんなく着こなすオシャレなKAEDEさん。愛用のバッグはルイ・ヴィトンがアーティストとコラボした個性的なバッグでした。<br></br>一見、「どんな服で持てばいいの？」と思ってしまいそうな独創的なデザインですが、彼女が手にしているのを見ると、あら不思議。自分でも、持てそうな気がしてきました（笑）</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/26/7.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>このバッグのここがスキ♡</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>KAEDEさん（以下、KAEDE）：</span>元々、油絵を描くのが趣味でアートはとっても身近な存在。美術館も大好きです。<br></br>そんな私にとって、ルイ・ヴィトンがアーティストとのコラボを始めたのは嬉しいニュースでした。<br></br>特に絵画好きなので、このジェフ・クーンズのシリーズはテンションが上ります（笑）次は草間彌生のコラボを持ってみたいな。</p>
        </div>
        <div className="text-max-width">
          <h2>使い勝手はどう？</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>KAEDE：</span>正直、購入するならシンプルなデザインで機能性を重視して選びます。例えば、ポケットが多かったり、中に仕切りがあったり。<br></br>でも、機能性ばかり気にしているとオシャレは楽しめなくて…。でも、ラクサスのバッグを使うなら思い切り冒険できます。今回のゴーギャンもまさにそれ。実際に使ってみると荷物もたくさん入るし、重さも気にならないです。<br></br>なにより、シンプルな服でも一気にオシャレ感が増すのは、機能的と言ってもいいかもしれません！</p>
        </div>
        <div className="text-max-width">
          <h2>LOUIS VUITTON×Jeff Koons</h2>
          <figure>
            <StaticImage src="../../images/posts/26/8.jpg" alt="" />
          </figure>          
          <p>LOUIS VUITTONはアーティストとのコラボレーションが盛んなブランドです。これまで、村上隆や草間彌生などの日本人アーティストとのコラボは国内でも話題になりました。<br></br>こちらはルイ・ヴィトン＆ジェフ・クーンズのコラボから誕生したMASTERSコレクションのGAUGUIN SPEEDY。ジェフ・クーンズはニューヨークを拠点に活躍するアーティストです。彼の「ゲイジング・ボール・ペインティング」という作品群から再現されました。<br></br>「ゲイジング・ボール・ペインティング」とは、西洋絵画の巨匠たちの作品をハンドペインティングで再現したもので、このゴーギャンの他にダ・ヴィンチやゴッホの作品もこのコラボで描かれています。
          </p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/26/9.jpg" alt="" />
          <span className="text-center">バッグの内側にも注目！</span>
        </figure>
        <figure　className="img-small">
          <StaticImage src="../../images/posts/26/10.jpg" alt="" />
          <span className="text-center">31x21x18cm</span>
        </figure>        
        <div className="text-max-width">
          <h2>＼これもオススメ！／</h2>
          <h2>LOUIS VUITTON×草間彌生【モノグラム・ウェーブネヴァーフル MM ジョーヌ】</h2>
          <p>こちらは草間彌生とのコラボで生まれたネヴァーフルMM。草間彌生の代表的なデザインであるパンプキンドットが描かれています。<br></br>ネヴァーフルMMはコンサバティブなイメージがあるラインですが、草間彌生のデザインが加われば、途端に個性的に！</p>          
          <figure className="img-small">
            <StaticImage src="../../images/posts/26/11.jpg" alt="" />
            <span className="text-center">31x29x16cm</span>
          </figure>          
        </div>
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>アルマ【アンプラント】</h2>
          <figure>
            <StaticImage src="../../images/posts/26/12.jpg" alt="" />
          </figure>          
          <p>ラグジュアリーブランド好きだけど、露骨なのは苦手。さりげないものに惹かれるというHITOMIさんが選んだのはこちら。<br></br>「アルマ」はルイ・ヴィトンの代表的なハンドバッグです。<br></br>丸みのあるデザインはクラシカルでエレガント、そんなイメージのアルマですが、サイドまで大きく開く間口や軽い素材など使い勝手も◎2WAYなのでストラップをつけてカジュアルに、トップハンドルで女性らしく！そんなイメージチェンジもできちゃいます。
          </p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/26/13.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>このバッグのここがスキ♡</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>HITOMIさん（以下、HITOMI）：</span>以前から、ヴィトンの「アルマ」か「スピーディ」を使ってみたいと思ってたんです。<br></br>なぜかって？実は、女性が活躍したって内容の本を読むのが好きなんですが、ココ・シャネルの本に出てきたのがきっかけです。<br></br>ココ・シャネルはCHANELのデザイナーですが、そんな彼女がルイ・ヴィトンでオーダーしたのが「アルマ」だそうです。そんなの聞くと持ってみたくなっちゃいますよね（笑）<br></br>ちなみに「スピーディ」は、オードリー・ヘップバーンがオーダーしたそうです。ふたりとも素敵な女性なので、憧れてしまいます。</p>
        </div>
        <div className="text-max-width">
          <h2>使い勝手はどう？</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>HITOMI：</span>丸いですし、荷物がたくさん入るタイプではないと思うけど大満足。だって、かわいいから（笑）<br></br>レジ袋が有料化になってから、購入する前提なら大きいバッグを選びがちになってました。でも、本当は小さいバッグが好きなんですよね。<br></br>ラクサスでバッグを選ぶときは、気持ちの赴くままに使ってみたいものを試すようにしています。定期的に交換してるので、もし使いにくかったとしても、後悔はしません。逆に、ラクサスで使ってみてよかった！って、ポジティブに思えます。</p>
        </div>
        <div className="text-max-width">
          <h2>アンプラント</h2>
          <figure>
            <StaticImage src="../../images/posts/26/14.jpg" alt="" />
          </figure>          
          <p>フランス語で刻印という意味をもつ「アンプラント」。上質なカーフレザーにエンボス加工で施されたモノグラム・モチーフが控えめで大人な印象。<br></br>使い込むほどにしなやかさを増し、味わい深くなるソフトカーフです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/26/15.jpg" alt="" />
          <span className="text-center">23x18x11cm</span>
        </figure>
        <div className="text-max-width">
          <h2>＼これもオススメ！／</h2>
          <h2>クリュニーBB【エピ・レザー】</h2>
          <p>さりげないルイ・ヴィトンがお好みならエピ・レザーがオススメ。線状の型押し、マットな質感は大人のエレガントスタイルにぴったり。アルマ同様、ストラップがついている2WAYタイプなので、シーンによって使い分け可能です。</p>          
          <figure className="img-small">
            <StaticImage src="../../images/posts/26/16.jpg" alt="" />
            <span className="text-center">25x19x9cm</span>
          </figure>          
        </div>
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>

        <div className="text-max-width">
          <h2>ロックミー【II BB】</h2>
          <figure>
            <StaticImage src="../../images/posts/26/17-1.jpg" alt="" />
          </figure>          
          <p>スタイル抜群でファッション大好きなMIYUさんが選んだのは、ルイ・ヴィトンの新しいシリーズ「LOCKME (ロックミー)」。<br></br>ファッション性と機能性を兼ね揃えていると人気のシリーズです。
          </p>
        </div>
        <div className="text-max-width">
          <h2>このバッグのここがスキ♡</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>MIYUさん（以下、MIYU）：</span>初めて持ったヴィトンは、モノグラムでした。きっと、みんなそうですよね（笑）<br></br>モノグラムタイプも合わせやすくて重宝しましたが、いろいろと使ってみたくなって。今、気に入っているのは、ピンクのロックミーです。<br></br>派手目の色だけど、ダークカラーになりがちな、秋冬コーデの差し色に重宝しています。</p>
        </div>
        <div className="text-max-width">
          <h2>使い勝手はどう？</h2>
          <p><span style={{fontWeight: 'bold', color: '#B67C29'}}>MIYU：</span>コンパクトなサイズですが、必要最低限のものは入るので通勤にも使っちゃってます。<br></br>小さめバッグは仕事帰りに食事に行くときも、おしゃれにキマリますよ（笑）<br></br>荷物が増えるときはトートバッグをプラスしたりして対応します。お財布やスマホなど貴重品はコレに入れて、嵩張るものはトートバック。そんなイメージです。</p>
        </div>
        <div className="text-max-width">
          <h2>なめらかな手触りのグレインカーフレザー</h2>
          <figure>
            <StaticImage src="../../images/posts/26/17.jpg" alt="" />
          </figure>          
          <p>ウットリするほどなめらかな手触りの理由は、柔らかいグレインカーフレザーを使用しているから。上質なレザーのボディと相反する硬い質感のチェーンのハンドルがスタイリッシュな印象を演出しています。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/26/18.jpg" alt="" />
          <span className="text-center">22x15x7cm</span>
        </figure>
        <div className="text-max-width">
          <h2>＼これもオススメ！／</h2>
          <h2>サントンジュ</h2>
          <p>中央のタッセルが可愛いサントンジュ。ダミエといえばベージュとブラウンの落ち着いたカラーリングですが、このダミエ・アズールはブルー×アイボリーの軽やかな色合いです。<br></br>タッセルとサイド、ストラップには淡いピンクが女の子らしい雰囲気。ダークカラーのコートと合わせてみて！</p>          
          <figure className="img-small">
            <StaticImage src="../../images/posts/26/19.jpg" alt="" />
            <span className="text-center">21x15x7cm</span>
          </figure>
        </div>                        
        <div className="text-two-cloumn">
          <h2>自分の「好き」を知る</h2>
          <p>今回、登場してくれた4名。見事に「好き」のポイントが違い、選んだバッグに個性が表れていました。<br></br>ファッションの楽しみ方は人それぞれ。トレンドを追いかけるのも、1つの楽しみ方です。でも、自分と向き合って好きなものを見つけるのもまた1つの方法。<br></br>みんなが好きなものじゃなくて、私の好きなものを持つ！そんな風にファッションを楽しめると、もっと自由になれそうだなぁ、と思ったのでした。<br></br>そして、自分のスタイルを確立した女性は魅力的です。オシャレを楽しんだ分だけ素敵な女性になれるなら、こんな最高なことはないですよね！</p>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post26

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 26}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
